import { Component, OnInit, ViewChild } from '@angular/core';
import { UploadOrdersService } from '../upload-orders.service';
import { NotificationsService } from '../../../shared/notifications/notifications.service';
import { DatePickerModalComponent } from '../../../shared/modals/date-picker-modal.component';
import { SimpleModalService } from 'ngx-simple-modal';
import axios from 'app/api/axios';
import { Store } from '@ngrx/store';
import { Consignment, Shipment } from '../consignment.interface';
import * as moment from 'moment';
import { completeAssign } from '../../../shared/helpers';
import { ActingAs, Warehouse } from 'app/interfaces/auth.interfaces';
import { selectorActingAs, selectorWarehouses } from 'app/auth/auth.reducer';
import { PhoneValidationPipe } from 'app/shared/pipes/phone-validation.pipe';
import { ButtonTypes } from 'app/shared/buttons/basic-button.component';
import { UiColors } from 'app/interfaces/ui.interfaces';
import { IconTypes } from 'app/shared/icon/icon.interfaces';

@Component({
  selector: 'app-edit-consignment',
  templateUrl: './edit-consignment.component.html',
  styleUrls: ['./edit-consignment.component.scss'],
})
export class EditConsignmentComponent implements OnInit {
  @ViewChild('file') file;
  zoneData = [];
  orderFound = false;
  invoiceData = [];
  lookUpValue;
  processing: boolean;
  chosenWarehouseName: string;
  warehouseOptions = [];
  override = false;
  parcelTypes = ['parcel-a4-envelope', 'parcel-small', 'parcel-medium', 'parcel-large', 'parcel-xlarge'];
  consignment: Consignment = {
    delivery_date: null,
    shift_start: null,
    shift_end: null,
    warehouse_id: null,
    warehouse_name: null,
    bucket_id: null,
  };
  shipment;
  shipmentData: Shipment = {
    invoice_number: null,
    consignment: null,
    delivery_window_start: null,
    delivery_window_end: null,
    address: null,
    contact: {
      customer_name: null,
      customer_phone: null,
    },
    parcels: {
      'parcel-a4-envelope': 0,
      'parcel-small': 0,
      'parcel-medium': 0,
      'parcel-large': 0,
      'parcel-xlarge': 0,
    },
  };

  actingAs: ActingAs;
  warehouses: Warehouse[];
  buttonTypes = ButtonTypes;
  uiColors = UiColors;
  iconTypes = IconTypes;

  constructor(
    public simpleModalService: SimpleModalService,
    public uploadOrdersService: UploadOrdersService,
    public store: Store<any>,
    public notificationService: NotificationsService,
    private phoneValidationPipe: PhoneValidationPipe
  ) {
    this.store.select(selectorActingAs).subscribe((next) => {
      this.actingAs = next;
    });
    this.store.select(selectorWarehouses).subscribe((next) => (this.warehouses = next));
    this.mapWarehouses();
    this.resetForm();
  }

  resetForm() {
    this.lookUpValue = null;
    this.shipment = completeAssign({}, this.shipmentData);
    this.shipmentData.contact.customer_name = null;
    this.shipmentData.contact.customer_phone = null;
    this.override = false;
  }

  checkValue(value) {
    if (value === '' || value === undefined || value === null) {
      return true;
    } else {
      return false;
    }
  }

  checkParcels() {
    const parcels: any = this.shipment.parcels;
    let boolean = false;
    if (Object.keys(parcels).every((k) => parcels[k] === 0)) {
      boolean = true;
    }
    return boolean;
  }

  overrideTrue() {
    this.override = true;
    const address = [
      this.shipment.address_line1,
      this.shipment.address_line2,
      this.shipment.address_line3,
      this.shipment.address_line4,
    ];
    this.shipment['address'] = address
      .filter(function (val) {
        return val;
      })
      .join(', ');
  }
  overrideFalse() {
    this.override = false;
    this.shipment['address'] = null;
  }

  validate() {
    if (this.checkValue(this.shipment.invoice_number)) {
      this.alertError('Please add an Invoice Number for this consignment');
    } else if (this.checkValue(this.shipment.contact.customer_name)) {
      this.alertError('Please add an Company Name for this consignment');
    } else if (!this.phoneValidationPipe.transform(this.shipment.contact.customer_phone)) {
      this.alertError('Please add a valid Phone number for this consignment');
    } else if (this.checkParcels()) {
      this.alertError('Please add at lease 1 parcel to this consignment.');
    } else {
      this.sendInvoiceData();
    }
  }

  alertError(message) {
    this.notificationService.publish({
      type: 'error',
      message: message,
    });
  }

  searchLookups(orderLookup) {
    axios
      .get(`/consignment/${this.actingAs.id}/order-by-lookup/` + orderLookup)
      .then((response) => {
        const data = response?.data;
        const date = moment(data.bucket.delivery_date).format('YYYY-MM-DD');
        this.consignment = data.bucket;
        this.consignment['delivery_date'] = date;
        this.shipment['invoice_number'] = data.invoice_number;
        this.shipment['consignment'] = data.consignment;
        this.shipment['contact'].customer_name = data.customer_name;
        this.shipment['contact'].customer_phone = data.customer_phone;
        this.shipment['address_line1'] = data.address_line1;
        this.shipment['address_line2'] = data.address_line2;
        this.shipment['address_line3'] = data.address_line3;
        this.shipment['address_line4'] = data.address_line4;
        this.shipment['order_id'] = data.order_id;
        this.shipment['flagged_reason'] = data.flagged_reason;
        this.shipment.parcels['parcel-a4-envelope'] = data.parcels['parcel-a4-envelope'];
        this.shipment.parcels['parcel-small'] = data.parcels['parcel-small'];
        this.shipment.parcels['parcel-medium'] = data.parcels['parcel-medium'];
        this.shipment.parcels['parcel-large'] = data.parcels['parcel-large'];
        this.shipment.parcels['parcel-xlarge'] = data.parcels['parcel-xlarge'];
        this.orderFound = true;
      })
      .catch((error) => {
        this.orderFound = false;
        this.notificationService.publish({
          type: 'error',
          message: error.response?.data.message,
        });
      });
  }

  mapWarehouses() {
    this.warehouses.forEach((warehouse) => {
      this.warehouseOptions.push({
        name: warehouse.name,
        value: warehouse.id,
      });
    });
  }

  setInitialValues() {
    this.lookUpValue = null;
    this.consignment.delivery_date = null;
    this.chosenWarehouseName = this.warehouses[0].name;
    this.consignment.warehouse_id = this.warehouses[0].id;
    this.consignment.warehouse_name = this.warehouses[0].name;
    this.orderFound = false;
  }

  uploadConsignmentData() {
    this.file.nativeElement.click();
  }

  addParcel(parcelType) {
    this.shipment.parcels[parcelType]++;
  }

  removeParcel(parcelType) {
    if (this.shipment.parcels[parcelType] > 0) {
      this.shipment.parcels[parcelType]--;
    }
  }

  onFileAdded() {
    this.processing = true;
    const file: { [key: string]: File } = this.file.nativeElement.files[0];
    this.uploadOrdersService
      .uploadConsignmentData(file)
      .then(() => {
        this.getInvoiceData();
        this.processing = false;
      })
      .catch(() => {
        this.processing = false;
      });
  }

  getInvoiceData() {
    axios.get(`/consignment/${this.actingAs.id}/zones`).then((response) => {
      this.zoneData = response?.data.zones;
    });
  }

  sendInvoiceData() {
    this.processing = true;
    const data = {
      consignment: this.consignment,
      shipment: this.shipment,
    };
    this.uploadOrdersService
      .setSingleConsignment(data)
      .then((response) => {
        this.processing = false;
        const blob = new Blob([response?.data], { type: 'application/pdf' });
        const blobURL = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobURL;
        document.body.appendChild(iframe);
        iframe.contentWindow.print();
        this.resetForm();
      })
      .catch(() => {
        this.processing = false;
      });
  }

  removeOrderFromConsignment() {
    this.uploadOrdersService.removeOrderFromConsignment(this.shipment.order_id).then(() => this.setInitialValues());
  }

  openDatePickerModal() {
    this.simpleModalService.addModal(DatePickerModalComponent).subscribe((date: any) => {
      if (!date) {
        return;
      }
      this.consignment.delivery_date = moment(date).format('YYYY-MM-DD');
    });
  }

  ngOnInit() {
    this.getInvoiceData();
    this.setInitialValues();
  }
}
